import React from 'react';
import { Button, makeStyles, mergeClasses, shorthands, tokens } from '@fluentui/react-components';
import { Navigation20Regular } from '@fluentui/react-icons';

import { useAppActions, useAppState } from '../context';
import AppHeaderPersona from './header/headerPersona';
import AppToggleFullscreenButton from './header/headerFullscreen';
import AppHeaderMenu from './header/headerMenu';

const useStyles = makeStyles({
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    flexBasis: 'auto',
    fontSize: tokens.fontSizeBase500,
    flexGrow: 0,
    flexShrink: 0,
    ...shorthands.padding('5px'),
    ...shorthands.borderBottom('1px', 'solid', 'gray'),
    boxShadow: tokens.shadow2,
    backgroundColor: tokens.colorBrandBackground,
    color: '#f0f0f0',
  },
  headerBlock: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerContentButton: {
    minWidth: 'unset',
  },
  headerContentButtonInternal: {
    transition: 'rotate 0.1s',
  },
  headerContentButtonActivated: {
    rotate: '90deg',
  },
  headerCompany: {
    ...shorthands.padding('5px', '20px'),
    fontWeight: tokens.fontWeightBold,
  },
  headerCompanyG: {
    display: 'inline-block',
    transform: 'translateY(1.5px)',
    fontSize: '28px',
    color: '#ffcc33',
  },
});
export function AppHeader(): JSX.Element {
  const styles = useStyles();
  const actions = useAppActions();
  const appState = useAppState();

  return (
    <header className={styles.header}>
      <div className={styles.headerBlock}>
        <Button
          appearance="primary"
          className={styles.headerContentButton}
          onClick={() => {
            if (appState.view.contentIsOpen) {
              actions.view.closeContent();
            } else {
              actions.view.openContent();
            }
          }}
        >
          <Navigation20Regular
            className={mergeClasses(
              styles.headerContentButtonInternal,
              appState.view.contentIsOpen && styles.headerContentButtonActivated,
            )}
          />
        </Button>

        {appState.view.inEditMode && <AppHeaderMenu />}
      </div>
      <div>Some order</div>
      <div className={styles.headerBlock}>
        <div className={styles.headerCompany}>
          GKN<div className={styles.headerCompanyG}>{'>'}</div> ILI
        </div>
        <AppToggleFullscreenButton appearance="primary" className={styles.headerContentButton} />
        <AppHeaderPersona />
      </div>
    </header>
  );
}
